import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingArgument } from './components/ClosingArgument';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { PricingSection } from './components/PricingSection';
import { ProductGallery } from './components/ProductGallery';
import { SolutionReveal } from './components/SolutionReveal';
import { SystemIntro } from './components/SystemIntro';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { VisualCoaching } from './components/VisualCoaching';
import { VolumesSection } from './components/VolumesSection';
import { gymSlides, insideSlides, sessionSlides } from './data/gallery';
import { META_PIXEL_ID } from './utils/tracking';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
interface AppProps {
  showTestimonials?: boolean;
}
export function App({
  showTestimonials = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const pixel: MetaPixel = (...args: unknown[]) => {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue?.push(args);
        };
        pixel.queue = [];
        pixel.loaded = true;
        pixel.version = '2.0';
        pixel.push = (...args: unknown[]) => pixel(...args);
        window.fbq = pixel;
        window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-zinc-950 text-zinc-400" data-id="element-0" data-mp="85bap1hsmn2g">
      <main data-id="element-1" data-mp="3gle88ef6yvd2">
        <Hero data-id="element-2" data-mp="3gl4pnbwh7qhe" />
        <ProductGallery heading="See inside MMA Coach Ready" description="Real pages from the system — visual progressions, coaching sequences, decision maps, corrections, drills and ready-to-use session structures." caption="This is what “open and coach” actually looks like." slides={insideSlides} data-id="element-3" data-mp="3gklbm69y5m8n" />
        {showTestimonials && <TestimonialsStrip data-id="element-4" data-mp="2xuwt5cna7ya6" />}
        <PainPoints data-id="element-5" data-mp="2xu3mscs8jask" />
        <SystemIntro data-id="element-6" data-mp="2xtbyzo4vqhcu" />
        <SolutionReveal data-id="element-7" data-mp="2xssebznuhev4" />
        <VolumesSection data-id="element-8" data-mp="2sw20liziivcv" />
        <VisualCoaching data-id="element-9" data-mp="2swlgyv9ilbos" />
        <ProductGallery heading="A system you can actually use in the gym" caption="Visual coaching pages designed for fast understanding, practical setup and immediate application." slides={gymSlides} tone="gray" data-id="element-10" data-mp="2svaeqzvpwbzs" />
        <BonusSection data-id="element-11" data-mp="ygd25u3tymkg" />
        <PricingSection data-id="element-12" data-mp="ygwjb8lnp6xf" />
        <ClosingArgument data-id="element-13" data-mp="ydija70gt9t5" />
        <ProductGallery heading="From technique to complete session" caption="A visual coaching system built to help coaches move from individual skills to complete MMA development." slides={sessionSlides} data-id="element-14" data-mp="13eexpeig0ect" />
        <Guarantee data-id="element-15" data-mp="1w20wm9gq6utc" />
        <FAQ data-id="element-16" data-mp="1w19fg3nvkzml" />
        <FinalCTA data-id="element-17" data-mp="1w0zn49fcygdq" />
      </main>
      <Footer data-id="element-18" data-mp="1i444bp9b1akh" />
      <noscript data-id="element-19" data-mp="1i2j87v7cdjki">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-20" data-mp="1i319x7crwpzt" />
      </noscript>
    </div>;
}